import { useMemo } from 'react';
import { createOption } from '@mews-commander/ui';
import { useAllCurrencies } from '../../hooks';

export const useAllCurrencyOptions = () => {
    const currencies = useAllCurrencies();

    return useMemo(
        () =>
            currencies.map((currency) =>
                createOption({
                    value: currency.code,
                    label: currency.code,
                })
            ),
        [currencies]
    );
};
